export default __webpack_public_path__ + "static/media/reactFooterLogo.59ef665e.svg";